import { Settlement } from "../settlement/settlement";
import { RegionModel } from "./region";
export class RegionGenerator {
    generate(regionGenConfiguration) {
        const region = new RegionModel();
        region.AreaSqMiles = regionGenConfiguration.RegionSizeSqMiles;
        region.Age = regionGenConfiguration.RegionAgeYears;
        region.TotalLivestock = regionGenConfiguration.RegionPopulation * regionGenConfiguration.LivestockPerPerson;
        region.Fowl = region.TotalLivestock * regionGenConfiguration.PercentageOfLivestockIsFowl;
        region.BurdenBeasts = region.TotalLivestock - region.Fowl;
        region.CastlesRuined = Math.floor(regionGenConfiguration.RegionPopulation * Math.sqrt(regionGenConfiguration.RegionAgeYears) /
            (regionGenConfiguration.PeoplePerRuinedCastle));
        region.CastlesActive = Math.floor(regionGenConfiguration.RegionPopulation / regionGenConfiguration.PeoplePerCastle);
        region.CastlesTotal = region.CastlesRuined + region.CastlesActive;
        region.CastlesInOutskirts = region.CastlesTotal * regionGenConfiguration.PercentageOfCastlesInOutskirts;
        region.Cities = [];
        region.Towns = [];
        let totalGeneratedPopulation = 0;
        let lastCityPopulation = Math.floor(Math.sqrt(regionGenConfiguration.RegionPopulation)) * (this.getRandomArbitraryInteger(2, 8) + 10);
        const capitol = new Settlement(lastCityPopulation, regionGenConfiguration);
        totalGeneratedPopulation += capitol.GetTotalPopulation();
        region.Cities.push(capitol);
        lastCityPopulation = this.getRandomArbitraryInteger(0.2, 0.8) * lastCityPopulation;
        while (lastCityPopulation > 8000) {
            const city = new Settlement(lastCityPopulation, regionGenConfiguration);
            region.Cities.push(city);
            const populationReduction = this.getRandomArbitraryInteger(0.1, 0.4);
            lastCityPopulation = lastCityPopulation * populationReduction;
            totalGeneratedPopulation += city.GetTotalPopulation();
        }
        const numTowns = region.Cities.length * this.getRandomArbitraryInteger(2, 16);
        region.Towns = [];
        while (region.Towns.length < numTowns && totalGeneratedPopulation < regionGenConfiguration.RegionPopulation) {
            let townPopulation = this.getRandomArbitraryInteger(1000, 8000);
            if (townPopulation + totalGeneratedPopulation > regionGenConfiguration.RegionPopulation) {
                townPopulation = regionGenConfiguration.RegionPopulation - totalGeneratedPopulation;
            }
            const settlement = new Settlement(townPopulation, regionGenConfiguration);
            region.Towns.push(settlement);
            totalGeneratedPopulation += settlement.GetTotalPopulation();
        }
        return region;
    }
    getRandomArbitraryInteger(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    }
}
//# sourceMappingURL=regiongenerator.js.map